export const MastersActions = {
  // Vessel Master Keys

  GET_VESSEL_MASTER_LIST: "GET_VESSEL_MASTER_LIST",
  SET_VESSEL_MASTER_LIST: "SET_VESSEL_MASTER_LIST",
  ADD_VESSEL_MASTER: "ADD_VESSEL_MASTER",
  UPDATE_VESSEL_MASTERS: "UPDATE_VESSEL_MASTERS",
  DELETE_VESSEL_MASTERS: "DELETE_VESSEL_MASTERS",
  SET_VESSEL_MASTER_PAGINATION: "SET_VESSEL_MASTER_PAGINATION",

  // Vessel Type Master Keys

  GET_VESSEL_TYPE_MASTERS_LIST: "GET_VESSEL_TYPE_MASTERS_LIST",
  SET_VESSEL_TYPE_MASTERS_LIST: "SET_VESSEL_TYPE_MASTERS_LIST",
  ADD_VESSEL_TYPE_MASTERS: "ADD_VESSEL_TYPE_MASTERS",
  UPDATE_VESSEL_TYPE_MASTERS: "UPDATE_VESSEL_TYPE_MASTERS",
  DELETE_VESSEL_TYPE_MASTERS: "DELETE_VESSEL_TYPE_MASTERS",
  SET_VESSEL_TYPE_MASTER_PAGINATION: "SET_VESSEL_TYPE_MASTER_PAGINATION",

  // Checklist Master and Checklist Question keys

  GET_CHECKLIST_MASTERS_LIST: "GET_CHECKLIST_MASTERS_LIST",
  SET_CHECKLIST_MASTERS_LIST: "SET_CHECKLIST_MASTERS_LIST",
  ADD_CHECKLIST_MASTERS: "ADD_CHECKLIST_MASTERS",
  UPDATE_CHECKLIST_MASTERS: "UPDATE_CHECKLIST_MASTERS",
  DELETE_CHECKLIST_MASTERS: "DELETE_CHECKLIST_MASTERS",
  GET_CHECKLIST_QUESTION_MASTERS_LIST: "GET_CHECKLIST_QUESTION_MASTERS_LIST",
  SET_CHECKLIST_QUESTION_MASTERS_LIST: "SET_CHECKLIST_QUESTION_MASTERS_LIST",
  ADD_CHECKLIST_QUESTION_MASTERS: "ADD_CHECKLIST_QUESTION_MASTERS",
  UPDATE_CHECKLIST_QUESTION_MASTERS: "UPDATE_CHECKLIST_QUESTION_MASTERS",
  GET_ALL_CHECKLIST_QUESTION_MASTERS_LIST:
    "GET_ALL_CHECKLIST_QUESTION_MASTERS_LIST",
  SET_ALL_CHECKLIST_QUESTION_MASTERS_LIST:
    "SET_ALL_CHECKLIST_QUESTION_MASTERS_LIST",
  SET_CHECKLIST_MASTER_PAGINATION: "SET_CHECKLIST_MASTER_PAGINATION",

  // Checklist Type Master keys

  GET_CHECKLIST_TYPE_MASTERS_LIST: "GET_CHECKLIST_TYPE_MASTERS_LIST",
  SET_CHECKLIST_TYPE_MASTERS_LIST: "SET_CHECKLIST_TYPE_MASTERS_LIST",
  ADD_CHECKLIST_TYPE_MASTERS: "ADD_CHECKLIST_TYPE_MASTERS",
  UPDATE_CHECKLIST_TYPE_MASTERS: "UPDATE_CHECKLIST_TYPE_MASTERS",
  DELETE_CHECKLIST_TYPE_MASTERS: "DELETE_CHECKLIST_TYPE_MASTERS",
  SET_CHECKLIST_TYPE_MASTER_PAGINATION: "SET_CHECKLIST_TYPE_MASTER_PAGINATION",

  // Role Master keys

  GET_ROLE_MASTER_LIST: "GET_ROLE_MASTER_LIST",
  SET_ROLE_MASTER_LIST: "SET_ROLE_MASTER_LIST",
  ADD_ROLE_MASTER: "ADD_ROLE_MASTER",
  DELETE_ROLE_MASTER: "DELETE_ROLE_MASTER",
  UPDATE_ROLE_MASTER: "UPDATE_ROLE_MASTER",

  // Screen Access Master keys

  GET_SCREEN_ACCESS_MASTER_LIST: "GET_SCREEN_ACCESS_MASTER_LIST",
  SET_SCREEN_ACCESS_MASTER_LIST: "SET_SCREEN_ACCESS_MASTER_LIST",
  ADD_SCREEN_ACCESS_MASTER: "ADD_SCREEN_ACCESS_MASTER",
  UPDATE_SCREEN_ACCESS_MASTER: "UPDATE_SCREEN_ACCESS_MASTER",
  DELETE_SCREEN_ACCESS_MASTER: "DELETE_SCREEN_ACCESS_MASTER",

  // Role Permission Master keys

  GET_ROLE_PERMISSION_MASTER_LIST: "GET_ROLE_PERMISSION_MASTER_LIST",
  SET_ROLE_PERMISSION_MASTER_LIST: "SET_ROLE_PERMISSION_MASTER_LIST",
  ADD_ROLE_PERMISSION_MASTER: "ADD_ROLE_PERMISSION_MASTER",
  DELETE_ROLE_PERMISSION_MASTER: "DELETE_ROLE_PERMISSION_MASTER",
  UPDATE_ROLE_PERMISSION_MASTER: "UPDATE_ROLE_PERMISSION_MASTER",

  // Company keys

  GET_COMPANY_LIST: "GET_COMPANY_LIST",
  SET_COMPANY_LIST: "SET_COMPANY_LIST",

  // User Master keys (Company Admin Master,Management Master,Vessel Admin Master,Superintendent Master)

  GET_USER_MASTER_LIST: "GET_USER_MASTER_LIST",
  SET_USER_MASTER_LIST: "SET_USER_MASTER_LIST",
  ADD_USER_MASTER: "ADD_USER_MASTER",
  UPDATE_USER_MASTER: "UPDATE_USER_MASTER",
  DELETE_USER_MASTER: "DELETE_USER_MASTER",

  // Department Master keys

  GET_DEPARTMENT_MASTER_LIST: "GET_DEPARTMENT_LIST",
  SET_DEPARTMENT_MASTER_LIST: "SET_DEPARTMENT_LIST",
  ADD_NEW_DEPARTMENT: "ADD_NEW_DEPARTMENT",
  DELETE_DEPARTMENT: "DELETE_DEPARTMENT",
  UPDATE_DEPARTMENT_MASTER: "UPDATE_DEPARTMENT_MASTER",

  // Checklist Question Master keys

  GET_QUESTION_CHECKLIST_MASTER_LIST: "GET_QUESTION_CHECKLIST_LIST",
  SET_QUESTION_CHECKLIST_MASTER_LIST: "SET_QUESTION_CHECKLIST_LIST",
  ADD_QUESTION_MASTER: "ADD_QUESTION_MASTER",
  UPDATE_QUESTION_MASTER: "UPDATE_QUESTION_MASTER",
  DELETE_QUESTION_CHECKLIST_MASTER: "DELETE_QUESTION_CHECKLIST_MASTER",
  SET_CHECKLIST_QUESTION_MASTER_PAGINATION:
    "SET_CHECKLIST_QUESTION_MASTER_PAGINATION",

  // Send Notification Master keys

  GET_SEND_NOTIFICATION_MASTER_LIST: "GET_SEND_NOTIFICATION_MASTER_LIST",
  SET_SEND_NOTIFICATION_MASTER_LIST: "SET_SEND_NOTIFICATION_MASTER_LIST",
  ADD_SEND_NOTIFICATION_MASTER: "ADD_SEND_NOTIFICATION_MASTER",

  // Support Master keys

  GET_SUPPORT_MASTER_LIST: "GET_SUPPORT_MASTER_LIST",
  SET_SUPPORT_MASTER_LIST: "SET_SUPPORT_MASTER_LIST",

  // For open or close model FOR  Send Notification master  keys

  IS_OPEN_MODELS_ADD_SEND_NOTIFICATION_MASTER:
    "IS_OPEN_MODELS_ADD_SEND_NOTIFICATION_MASTER",

  // For open or close model FOR  Departmen master  keys

  IS_OPEN_MODELS_ADD_DEPARTMENT_MASTER: "IS_OPEN_MODELS_ADD_DEPARTMENT_MASTER",
  IS_OPEN_MODELS_EDIT_DEPARTMENT_MASTER:
    "IS_OPEN_MODELS_EDIT_DEPARTMENT_MASTER",

  // For open or close model FOR User Master keys (Company Admin Master,Management Master,Vessel Admin Master,Superintendent Master)

  IS_OPEN_MODELS_ADD_USER_MASTER: "IS_OPEN_MODELS_ADD_USER_MASTER",
  IS_OPEN_MODELS_EDIT_USER_MASTER: "IS_OPEN_MODELS_EDIT_USER_MASTER",

  // For open or close model FOR  Checklist Question master  keys

  IS_OPEN_MODELS_ADD_QUESTION_MASTER: "IS_OPEN_MODELS_ADD_QUESTION_MASTER",
  IS_OPEN_MODELS_EDIT_QUESTION_MASTER: "IS_OPEN_MODELS_EDIT_QUESTION_MASTER",

  // For open or close model FOR Checklist Type  keys

  IS_OPEN_MODELS_ADD_CHECKLIST_TYPE_MASTER:
    "IS_OPEN_MODELS_ADD_CHECKLIST_TYPE_MASTER",
  IS_OPEN_MODELS_EDIT_CHECKLIST_TYPE_MASTER:
    "IS_OPEN_MODELS_EDIT_CHECKLIST_TYPE_MASTER",

  // For open or close model FOR  Vessel Type Master  keys

  IS_OPEN_MODELS_ADD_VESSEL_TYPE_MASTER:
    "IS_OPEN_MODELS_ADD_VESSEL_TYPE_MASTER",
  IS_OPEN_MODELS_EDIT_VESSEL_TYPE_MASTER:
    "IS_OPEN_MODELS_EDIT_VESSEL_TYPE_MASTER",

  // For open or close model FOR  Vessel Master  keys

  IS_OPEN_MODELS_ADD_VESSEL_MASTER: "IS_OPEN_MODELS_ADD_VESSEL_MASTER",
  IS_OPEN_MODELS_EDIT_VESSEL_MASTER: "IS_OPEN_MODELS_EDIT_VESSEL_MASTER",

  // For Master pagination keys

  SET_PAGINATION_MASTER: "SET_PAGINATION_MASTER",

  // define other action types here
};
